import { number, string, func, bool, } from 'prop-types';
import styled from 'styled-components';
import Button from '../../../StoraEnsoComponents/Button';

const Wrapper = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 48px;
  padding-bottom: 16px;
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 65%, rgba(255,255,255,0) 100%);
  z-index: 20;

  ${Button} {
    margin: 4px;
    width: 80%;
  }

  @media screen and (min-width: 576px) {
    flex-direction: row;

    ${Button} {
      margin: 0 8px;
      width: 200px;
    }
  }
`;

function NavigationButtons({
  currentStep,
  isNextDisabled,
  nextBtnLabel,
  onBackClick,
  onNextClick,
}) {
  return (
    <Wrapper>
      <Button kind="secondary" disabled={currentStep === 1} onClick={onBackClick}>Back</Button>
      <Button onClick={onNextClick} disabled={isNextDisabled}>{nextBtnLabel}</Button>
    </Wrapper>
  );
}

NavigationButtons.propTypes = {
  currentStep: number.isRequired,
  isNextDisabled: bool.isRequired,
  nextBtnLabel: string,
  onBackClick: func,
  onNextClick: func.isRequired,
};

NavigationButtons.defaultProps = {
  nextBtnLabel: 'Next',
  onBackClick: () => {},
}

export default NavigationButtons;